<template>
  <div class="home">
    <div class="slide-back-image">
      <div class="overlay-effect"></div>
      <div class="container">
        <div class="row">
          <div class="center">
            <div class="col-12">
              <div
                class="d-flex justify-content-center flex-column align-items-center"
              >
                <h1
                  class="text-white text-center font-weight-bold animate__animated animate__fadeInDown"
                >
                  Hire the best freelancers <br />
                  for any job, online.
                </h1>

                <div class="mt-5 animate__animated animate__fadeInUp" >
                  <vs-button
                  style="font-size:18px"
                    circle
                    block
                    color="success"
                    gradient
                    @click="gottoFreelancers"
                  >
                    Hire Freelancers
                  </vs-button>
                </div>

                <!-- <div class="input-group search-input mt-5 animate__animated animate__fadeInUp">
                <input type="text" class="form-control p-4" placeholder="Hire Freelancer" />
                <div class="input-group-append">
                  <vs-button
                  class="btn btn-success p-2 m-0 background-startsec1"
                  color="#41b883"
                  flat
                    icon
                    animation-type="rotate"
                  >
                    <i style="color:white" class='bx bx-search'></i>
                    <template #animate >
                      <i style="color:white" class='bx bx-search-alt' ></i>
                    </template>
                  </vs-button>
                </div>
              </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="how-works bg-white text-center py-5">
      <div class="container" data-aos="fade-up">
        <header class="section-header mb-5">
          <h3>How Worker Works</h3>
        </header>
        <div class="row row-eq-height justify-content-center">
          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="100">
            <div class="">
              <!-- <i class="fas fa-file-invoice font-9 "></i> -->
              <img
                src="./../../src/assets/icons/file-invoice-solid updated.svg"
                style="width: 37.5px; height: 50px"
                class="img-fluid"
              />
              <div class="card-body">
                <h5 class="card-title">Add Project</h5>
                <p class="card-text" style="color: #666">
                  Add project for free and be ready to choose the best deal
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="200">
            <div class=" ">
              <!-- <i class="fas fa-hand-holding-usd font-9"></i> -->
              <img
                src="./../../src/assets/icons/hand-holding-usd-solid updated.svg"
                style="width: 56.25px; height: 50px"
                class="img-fluid"
              />

              <div class="card-body">
                <h5 class="card-title">Choose Deal</h5>
                <p class="card-text" style="color: #666">
                  Choose the best deal and start the project proccess
                </p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="300">
            <div class=" ">
              <!-- <i class="fas fa-user-tie font-9"></i> -->
              <img
                src="./../../src/assets/icons/user-tie-solid updated.svg"
                style="width: 43.75px; height: 50px"
                class="img-fluid"
              />
              <div class="card-body">
                <h5 class="card-title">Hire The Best</h5>
                <p class="card-text" style="color: #666">
                  Choose the best worker and hire him
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="why-us py-5 text-center">
      <div class="container" data-aos="fade-up">
        <header class="section-header mb-5">
          <h3>Why Worker ?</h3>
        </header>
        <div class="row row-eq-height justify-content-center">
          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="100">
            <div class="">
              <!-- <i class="fas fa-briefcase font-9 "></i> -->
              <img
                src="./../../src/assets/icons/briefcase-solid updated.svg"
                style="width: 50px; height: 50px"
                class="img-fluid"
              />

              <div class="card-body">
                <h5 class="card-title">Compleate Project easily</h5>
                <p class="card-text" style="color: #666">
                  Add your project and leave the task of implementing it to the
                  best experts in the world
                </p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="200">
            <div class=" ">
              <!-- <i class="fas fa-paper-plane font-9"></i> -->

              <img
                src="./../../src/assets/icons/paper-plane-solid updated.svg"
                style="width: 50px; height: 50px"
                class="img-fluid"
              />
              <div class="card-body">
                <h5 class="card-title">Hire The Best Freelancer</h5>
                <p class="card-text" style="color: #666">
                  Choose the freelancers you see and hire them directly
                </p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="300">
            <div class=" ">
              <!-- <i class="fas fa-credit-card font-9"></i> -->
              <img
                src="./../../src/assets/icons/credit-card-solid updated.svg"
                style="width: 56.25px; height: 50px"
                class="img-fluid"
              />

              <div class="card-body">
                <h5 class="card-title">Pay with your rights guaranteed</h5>
                <p class="card-text" style="color: #666">
                  pay for the work that is done and the balance remains in your
                  account until the project complete
                </p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="200">
            <div class=" ">
              <!-- <i class="fas fa-users font-9"></i> -->
              <img
                src="./../../src/assets/icons/users-solid updated.svg"
                style="width: 62.5px; height: 50px"
                class="img-fluid"
              />

              <div class="card-body">
                <h5 class="card-title">Biuld Amizang teams</h5>
                <p class="card-text" style="color: #666">
                  Experts in various fields and from different countries are
                  ready to serve you
                </p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="300">
            <div class=" ">
              <!-- <i class="fas fa-user-tie font-9"></i>  -->

              <img
                src="./../../src/assets/icons/user-tie-solid updated 2.svg"
                style="width: 43.75px; height: 50px"
                class="img-fluid"
              />

              <div class="card-body">
                <h5 class="card-title">Get your business done quickly</h5>
                <p class="card-text" style="color: #666">
                  Browse the freelancers , see their work spamples, and skills
                  and hire the best
                </p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="400">
            <div class="">
              <!-- <i class="fas fa-dollar-sign font-9"></i> -->

              <img
                src="./../../src/assets/icons/dollar-sign-solid updated.svg"
                style="width: 28.13px; height: 50px"
                class="img-fluid"
              />

              <div class="card-body">
                <h5 class="card-title">your projects at the lowest cost</h5>
                <p class="card-text" style="color: #666">
                  Hire the best expertise according to your budget
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="categories bg-white text-center py-5">
      <div class="container" data-aos="fade-up">
        <header class="section-header mb-5">
          <h3>Categories</h3>
        </header>
        <div class="row row-eq-height justify-content-center">
          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="100">
            <div
              class="card p-4 animate-up text-center d-flex justify-content-center flex-column align-items-center"
            >
              <!-- <i class="fas fa-paint-brush font-9 "></i> -->
              <img
                src="./../../src/assets/icons/paint-brush-solid updated.svg"
                style="width: 50px; height: 50px"
                class="img-fluid"
              />

              <div
                class="card-body d-flex justify-content-center flex-column align-items-center"
              >
                <h5 class="card-title">Design and works</h5>
                <p class="card-text" style="color: #666">
                  Graphic design interior engineering and planning Motion
                  graphic design
                </p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="200">
            <div
              class="card p-4 animate-up d-flex justify-content-center flex-column align-items-center"
            >
              <!-- <i class="fas fa-language font-9"></i> -->
              <img
                src="./../../src/assets/icons/language-solid updated.svg"
                style="width: 62.5px; height: 50px"
                class="img-fluid"
              />

              <div
                class="card-body d-flex justify-content-center flex-column align-items-center"
              >
                <h5 class="card-title">Translation and languages</h5>
                <p class="card-text" style="color: #666">
                  Legal translation, general translation, and technical
                  translation
                </p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="300">
            <div
              class="card p-4 animate-up d-flex justify-content-center flex-column align-items-center"
            >
              <!-- <i class="fas fa-code font-9"></i> -->
              <img
                src="./../../src/assets/icons/code-solid updated.svg"
                style="width: 62.5px; height: 50px"
                class="img-fluid"
              />

              <div
                class="card-body d-flex justify-content-center flex-column align-items-center"
              >
                <h5 class="card-title">Programming and development</h5>
                <p class="card-text" style="color: #666">
                  Software development, programming, support and application
                  development
                </p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="200">
            <div
              class="card p-4 animate-up justify-content-center flex-column align-items-center"
            >
              <!-- <i class="fas fa-pencil-alt font-9"></i> -->
              <img
                src="./../../src/assets/icons/pen-alt-solid updated.svg"
                style="width: 50px; height: 50px"
                class="img-fluid"
              />

              <div
                class="card-body d-flex justify-content-center flex-column align-items-center"
              >
                <h5 class="card-title">Writing and editing</h5>
                <p class="card-text" style="color: #666">
                  Content writing, research and reports, editing and auditing
                </p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="300">
            <div
              class="card p-4 animate-up justify-content-center flex-column align-items-center"
            >
              <!-- <i class="fas fa-lightbulb font-9"></i> -->
              <img
                src="./../../src/assets/icons/lightbulb-solid updated.svg"
                style="width: 62.5px; height: 50px"
                class="img-fluid"
              />

              <div
                class="card-body d-flex justify-content-center flex-column align-items-center"
              >
                <h5 class="card-title">Sales and marketing</h5>
                <p class="card-text" style="color: #666">
                  E-marketing, social media campaigns, and pricing strategies
                </p>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="400">
            <div
              class="card p-4 animate-up justify-content-center flex-column align-items-center"
            >
              <!-- <i class="fas fa-comments font-9"></i> -->
              <img
                src="./../../src/assets/icons/comments-solid updated.svg"
                style="width: 65.25px; height: 50px"
                class="img-fluid"
              />

              <div
                class="card-body d-flex justify-content-center flex-column align-items-center"
              >
                <h5 class="card-title">Consulting and training</h5>
                <p class="card-text" style="color: #666">
                  Provide advice, experiences and reviews and share experiences
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="background-startsec">
      <div class="container" data-aos="zoom-in">
        <div class="row">
          <div class="col-12 text-center">
            <div
              class="p-5 d-flex justify-content-center flex-column align-items-center"
            >
              <h3 class="text-white">Are You Ready To Start Your Project?</h3>
              <vs-button color="#fff" border @click="signUp">
                Get Started
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.slide-back-image {
  background-image: url("./../../src/assets/images/homepage-slide-8.jpg");
  height: 90vh; /* You must set a specified height */
  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 100%;
}
.overlay-effect {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 1;
  background-color: #0000002f;
  overflow: hidden;
}
.font-9 {
  font-size: 50px;
}
.background-startsec {
  background-color: #41b883;
}
.search-input {
  width: 50%;
}
@media only screen and (max-width: 700px) {
  .search-input {
    width: 100%;
  }
}
.background-startsec1 {
  background-color: #41b883;
}
.background-startsec1:hover {
  background-color: #369a6e;
}
.card {
  min-height: 280px;
}
.animate-up {
  -webkit-transition: top ease 0.5s;
  -moz-transition: top ease 0.5s;
  -o-transition: top ease 0.5s;

  transition: top ease 0.5s;
  position: relative;
  top: 0;
}
.animate-up:hover {
  top: -10px;
  cursor: pointer;
}
</style>

<script>
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init({
  once: true,
});
export default {
  methods: {
    signUp() {
      this.$router.push("/register");
    },
    gottoFreelancers(){
            this.$router.push("/freelancers");
    }
  },
};
</script>
